export default __webpack_public_path__ + "static/media/mm-edge-week-18.7edcc75c.jpg";